import { useState, useEffect } from 'react';
import { BookingRequest } from '../../types/booking';
import { adminService } from '../../services/adminService';

export function useAdminDashboard() {
  const [bookings, setBookings] = useState<BookingRequest[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    loadBookings();
  }, []);

  const showToastMessage = (message: string) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const loadBookings = async () => {
    try {
      setIsLoading(true);
      const response = await adminService.getBookings();
      if (response.success && response.data) {
        setBookings(response.data);
      }
    } catch (error: any) {
      setError('Erreur lors du chargement des réservations');
      console.error('Erreur:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (bookingId: number, newStatus: string) => {
    try {
      const response = await adminService.updateBookingStatus(bookingId, newStatus);
      if (response.success) {
        await loadBookings();
        showToastMessage('Statut mis à jour avec succès !');
      }
    } catch (error: any) {
      setError('Erreur lors de la mise à jour du statut');
      console.error('Erreur:', error);
    }
  };

  const handleDelete = async (bookingId: number) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette réservation ?')) {
      try {
        const response = await adminService.deleteBooking(bookingId);
        if (response.success) {
          await loadBookings();
          showToastMessage('Réservation supprimée avec succès !');
        }
      } catch (error: any) {
        setError('Erreur lors de la suppression');
        console.error('Erreur:', error);
      }
    }
  };

  const getStatistics = () => {
    const total = bookings.length;
    const pending = bookings.filter(b => b.status === 'pending').length;
    const confirmed = bookings.filter(b => b.status === 'confirmed').length;
    const completed = bookings.filter(b => b.status === 'completed').length;
    
    return { total, pending, confirmed, completed };
  };

  return {
    bookings,
    isLoading,
    error,
    toastMessage,
    showToast,
    showToastMessage,
    handleStatusChange,
    handleDelete,
    getStatistics
  };
}
